export enum EventTopic {
  TO_DO_LIST_CHANGED,
  TO_DO_ITEM_TO_EDIT,
  LANGUAGE_CHANGED,
  SELECT_ENTITY,
  CONFIG_CHANGED,
}
